// Collection page. On wide screens a filter checkbox submits the form at once. On phones the
// filter sidebar and the sort list are bottom sheets: the toolbar buttons open them, the close
// button, the backdrop and Escape close them, and focus stays inside while open.
(function () {
  'use strict';

  var phone = window.matchMedia('(max-width: 820px)');
  var openSheet = null;
  var opener = null;

  // Visible controls inside the open sheet, in tab order; the panel itself only holds focus on open.
  function focusable(sheet) {
    return Array.prototype.filter.call(
      sheet.querySelectorAll('a[href], button:not([disabled]), input:not([disabled])'),
      function (el) { return el.getClientRects().length > 0; }
    );
  }

  function open(sheet, button) {
    openSheet = sheet;
    opener = button;
    sheet.classList.add('is-open');
    button.setAttribute('aria-expanded', 'true');
    sheet.setAttribute('role', 'dialog');
    sheet.setAttribute('aria-modal', 'true');
    document.body.classList.add('drawer-open');
    sheet.querySelector('.catalog__sheet-panel').focus();
    document.addEventListener('keydown', onKeydown);
  }

  function close() {
    if (!openSheet) return;
    openSheet.classList.remove('is-open');
    openSheet.removeAttribute('role');
    openSheet.removeAttribute('aria-modal');
    document.body.classList.remove('drawer-open');
    document.removeEventListener('keydown', onKeydown);
    if (opener) {
      opener.setAttribute('aria-expanded', 'false');
      opener.focus();
    }
    openSheet = null;
    opener = null;
  }

  function onKeydown(event) {
    if (event.key === 'Escape') {
      close();
      return;
    }
    if (event.key !== 'Tab') return;
    var items = focusable(openSheet);
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];
    var inside = items.indexOf(document.activeElement) !== -1;
    // From the panel (focused on open) or anything outside the list, Tab wraps to the ends.
    if (event.shiftKey && (document.activeElement === first || !inside)) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && (document.activeElement === last || !inside)) {
      event.preventDefault();
      first.focus();
    }
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-sheet-open]');
    if (button) {
      var sheet = document.getElementById(button.dataset.sheetOpen);
      if (sheet) open(sheet, button);
      return;
    }
    if (event.target.closest('[data-sheet-close]')) close();
  });

  // Leaving phone width with a sheet open would strand the page behind the scroll lock.
  phone.addEventListener('change', function (event) {
    if (!event.matches) close();
  });

  document.addEventListener('change', function (event) {
    var input = event.target.closest('[data-filter-input]');
    if (!input) return;
    input.closest('.catalog__check').classList.toggle('is-checked', input.checked);
    // In the phone sheet the visitor picks several values and applies them with the button.
    if (!phone.matches) input.form.submit();
  });

  document.documentElement.classList.add('catalog-js');
})();
